import { DetailController } from 'controllers';
import { withBaseMultiSelect } from 'shared/HOC';

const DetailsSelect = withBaseMultiSelect(DetailController.getDetails());
export default DetailsSelect;
